module.exports = __webpack_public_path__ + "img/security.0780ccd1.png";